export default __webpack_public_path__ + "static/media/java.d1408ebc.png";